<template>
  <div id="app">
    <component :is="view" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StartView from '@/views/StartView.vue'
import EndView from '@/views/EndView.vue'
import SelectPlayerView from '@/views/SelectPlayerView.vue'
import SelectCharacterView from '@/views/SelectCharacterView.vue'
import SelectStoryView from '@/views/SelectStoryView.vue'
import StoryView from '@/views/StoryView.vue'
import NotSupportedView from '@/views/NotSupportedView.vue'

const isSupported = () => window.innerWidth >= 768 && window.innerHeight >= 600

export default {
  name: 'App',
  components: {
    StartView,
    EndView,
    SelectPlayerView,
    SelectCharacterView,
    SelectStoryView,
    StoryView,
    NotSupportedView
  },
  computed: mapState([
    'view'
  ]),
  methods: {
    ...mapActions([
      'loadScene'
    ]),
    onResize () {
      !isSupported() && this.loadScene({ name: 'NotSupported' })
    }
  },
  created () {
    window.addEventListener('resize', this.onResize)
    const name = isSupported() ? 'Start' : 'NotSupported'
    this.loadScene({ name })
  }
}
</script>

<style lang="scss">
#app {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  user-select: none;
  color: $color-black;
}
</style>
